import { apiv2Get } from '@/lib/apiv2';
import { eventPost } from '@/lib/events';

export interface CarePathwayPreset {
  preset_id: string | number;
  name: string;
  active?: boolean;
  [key: string]: unknown;
}

export interface ResolvePathwayInput {
  withingsUserId?: string | number | null;
  selected?: string[];
  ckdStage?: string | null;
}

export interface ApplyPathwayInput {
  withingsUserId: string | number;
  selected?: string[];
  ckdStage?: string | null;
  approvedBy?: string | null;
  // First-care-team-review attribution for the durable context.onboarding_review
  // flag — stamped by WF36 WITHOUT triggering clinical plan approval (approvedBy).
  confirmedBy?: string | null;
  // The diagnosis the clinician attested in the picker preview (canonical labels).
  // WF36 forwards it as changes.conditions so WF15 writes it + re-derives the ICD
  // bundle/track coherently. Absent → the apply never touches the diagnosis.
  confirmedConditions?: string[] | null;
}

export async function listCarePathwayPresets(): Promise<CarePathwayPreset[]> {
  const rows = await apiv2Get('care-pathway-presets', { active_only: 'true' });
  return rows || [];
}

export async function resolveCarePathway(
  { withingsUserId, selected, ckdStage }: ResolvePathwayInput,
): Promise<unknown> {
  return eventPost('pathway_resolve_requested', {
    id_dev_user: withingsUserId ? String(withingsUserId) : null,
    trigger_source: 'care_team_ui',
    selected: Array.isArray(selected) ? selected : [],
    ckd_stage: ckdStage || null,
  });
}

export async function applyCarePathway(
  {
    withingsUserId, selected, ckdStage, approvedBy, confirmedBy, confirmedConditions,
  }: ApplyPathwayInput,
): Promise<unknown> {
  return eventPost('pathway_apply_requested', {
    id_dev_user: String(withingsUserId),
    trigger_source: 'care_team_ui',
    selected: Array.isArray(selected) ? selected : [],
    ckd_stage: ckdStage || null,
    approved_by: approvedBy || null,
    confirmed_by: confirmedBy || null,
    confirmed_conditions: Array.isArray(confirmedConditions) && confirmedConditions.length
      ? confirmedConditions.map(String)
      : null,
  });
}
